

















































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import labelOperation from '@/components/label/labelOperation.vue';
import CommentList from '@/components/comment/commentList.vue';
import MarkedText from '@/components/marked/markedText.vue';
import DetailBox from '@/components/detailBox/detailBox.vue';
import RequirementSolution from './requirementSolution.vue';
import RequirementModuleList from './requirementModule.vue';
import { createLabelUrl } from '@/components/label/labelOperation';
import { createCommentUrl } from '@/components/comment/commentOperation';

type IRequirementInfo = IRequirement.IResponse.IRequirementInfo;
type ILabelInfo = ILabel.IResponse.ILabelInfo;
type ICreateOrUpdateComment = IComment.IRequest.ICreateOrUpdateComment;

@Component({
  components: {
    DetailBox,
    labelOperation,
    CommentList,
    MarkedText,
    RequirementSolution,
    RequirementModuleList,
  },
})
export default class RequirementDetail extends Vue {
  @Prop({ default: false }) private spinning!: boolean;
  @Prop({ required: true }) private requirement!: IRequirementInfo;
  get requirementId(): string {
    if (this.requirement) {
      return this.requirement.id;
    } else {
      return '';
    }
  }
  get labelUrl() {
    return createLabelUrl('Requirement', this.requirementId);
  }
  get commentUrl() {
    return createCommentUrl('Requirement', this.requirementId);
  }
  @Watch('requirementId')
  private watchRequirementId(newRequirementId: string) {
    if (newRequirementId) {
      this.requestRequirementDetail();
    }
  }
  private requestRequirementDetail() {
    this.$emit('refreshDetail', this.requirement);
  }
  private editRequirement() {
    this.$emit('edit', this.requirement);
  }
  private handleLabelChange(newLabels: ILabelInfo[]) {
    this.$emit('labelChange', { requirement: this.requirement, labels: newLabels });
  }
  private handleCommentAdd(newComment: ICreateOrUpdateComment) {
    this.$emit('commentChange', {
      requirement: this.requirement,
      comment: newComment,
      type: 'ADD',
    });
  }
  private editStatus(status: IRequirement.IRequirementStatus) {
    this.$emit('statusChange', {
      requirement: this.requirement,
      status,
    });
  }
  private handleDelRequirement() {
    this.$emit('delete', this.requirementId);
  }
  private goIssuePage(issueId: string): void {
    this.$router.push({
      name: 'Issue',
      params: {
        id: issueId,
      },
    });
  }
}
